import { render, staticRenderFns } from "./PlatformScheme.vue?vue&type=template&id=7de0e4a5&scoped=true&"
import script from "./PlatformScheme.vue?vue&type=script&lang=js&"
export * from "./PlatformScheme.vue?vue&type=script&lang=js&"
import style0 from "./PlatformScheme.vue?vue&type=style&index=0&id=7de0e4a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de0e4a5",
  null
  
)

export default component.exports